/**
 * Check's if the given event was triggered by a mouse click
 * @param $event
 */
export function cameFromClick($event) {
	return (
		($event &&
			($event.type === 'click' || ($event.event && $event.event.originalEvent && $event.event.originalEvent.type === 'click'))) ||
		false
	);
}
